import { createRoot } from 'react-dom/client';

export function mountReactApp(node, element) {
  const root = createRoot(node);
  root.render(element);
  return root;
}
